<template>
    <base-resource :booking_id="booking_id" :resource="resource" :headers="showHeaders"
                   :element_list="form_content" :read-only="showInReadMode" :data-decoration="decor"/>
</template>
<script>
    import BaseResource from '../../../../components/base/Resource'
    import DateTimeHelper from "../../../../helpers/datetime"

    export default {
        name: "ShippingBillResource",
        props: ['booking_id', 'readOnly'],
        components: {
            BaseResource
        },
        data: () => ({
            resource: 'shipping_bill',
            headers: [
                { sortable: false, divider: true, align: 'start', text: 'Shipping Bill', value: 'number' },
                { sortable: false, divider: true, align: 'start', text: 'Date', value: 'date' },
                { sortable: false, divider: true, align: 'start', text: 'Created At', value: 'created_at' },
                { sortable: false, divider: true, align: 'start', text: 'Created By', value: 'created_by' }
            ],
            readOnlyHeaders: [
                { sortable: false, divider: true, align: 'start', text: 'Shipping Bill', value: 'number' },
                { sortable: false, divider: true, align: 'start', text: 'Date', value: 'date' }
            ],
            form_content: [
                { md: '12', id: 'number', label: 'S Bill No', type: 'text-field', required: true },
                { md: '12', id: 'date', label: 'Date', type: 'date-picker', required: true },
                { md: '12', id: 'remark', label: 'Remark', type: 'textarea', required: false, validate: true }
            ],
            decor: (items = []) => {
                if(items.length == 0) {
                    return [];
                }
                items.forEach(x => x.created_at = DateTimeHelper.getDisplayDate(x.created_at));
            },
        }),
      computed: {
          showInReadMode() {
            return this.readOnly || false;
          },
          showHeaders() {
              return this.readOnly ? this.readOnlyHeaders: this.headers;
          }
      }
    }
</script>